//import { createApp } from 'vue'
import { defineCustomElement} from 'vue'
import App from './App.vue'
import { ensureFonts } from './plugins/fonts.ts'
import styles_datepicker from '@vuepic/vue-datepicker/dist/main.css?raw'
import styles_iway from "./styles.default.css?raw"
let styles_datepicker_local = styles_datepicker
    .split(":root").join(":host");// :root ersetzen
let styles_local = styles_iway
    .split(":root").join(":host"); // :root ersetzen
App.styles = [styles_datepicker_local, styles_local];
//createApp(App).mount('#app')

ensureFonts();
const TheElement = defineCustomElement(App);
customElements.define('tsm-webcomponent', TheElement);


// Example of disabling shadow DOM
// const LightDomElement = defineCustomElement({
//   ...MyComponent,
//   shadow: false // Renders in light DOM
//})

// Zudem haben wir auch in App.Vue noch shadowrootmode="closed" gesetzt
// https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM